import axios from "axios";
import { format, lastDayOfMonth } from "date-fns";
import React, { Component } from "react";
import MerchantReportsFilter from "./MerchantReportsFilter";
import MerchantReport from "./components/merchantReport";
import AcquisitionReportsFilter from "./AcquisitionReportsFilter";
import { acquisition_reports } from "./configs/AcquisitionReportsConfig";

export default class AcquisitionReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: null,
      fetchingFileName: "",
    };
  }

  generatePostBody = (item) => {
    const filter = { ...this.state.filter };

    const monthID = filter["month"].value;
    const yearID = filter["year"].value;
    if (monthID === "") {
      alert("Please select a month");
      return null;
    }

    const reg_start_date = format(new Date(), `${yearID}-${monthID}-01`);

    const reg_end_date = format(
      lastDayOfMonth(new Date(reg_start_date)),
      "yyyy-MM-dd"
    );

    return {
      reg_start_date: reg_start_date,
      reg_end_date: reg_end_date,
      region: filter["regions"].value,
      territory: filter["territories"].value,
      area: filter["areas"].value,
      agency: filter["agency"].value,
    };
  };

  download = (item) => {
    const body = this.generatePostBody(item);
    console.log(body);
    if (body === null) {
      return;
    }

    this.setState({ fetchingFileName: item.filename });
    axios
      .post(
        `${process.env.REACT_APP_API_URL}${item.url}`,
        {
          ...body,
        },

        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${item.filename}_${format(new Date(), "yyyy-MM-dd")}_${format(
            new Date(),
            "yyyy-MM-dd"
          )}.${item.file_type}`
        );
        document.body.appendChild(link);
        link.click();
      })
      .then(() => this.setState({ fetchingFileName: "" }))
      .catch((err) => {
        this.setState({ fetchingFileName: "" });
        alert(
          "Something went wrong ! Please contact your administrator for details. "
        );
      });
  };

  render() {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ width: "75%" }}>
          <div className="card-row row">
            {acquisition_reports.map((item, index) => (
              <div key={index} className="card-col col l4 m6 s12">
                <MerchantReport
                  isCompactView={false}
                  report={item}
                  callBack={() => this.download(item)}
                  fetching={item.filename === this.state.fetchingFileName}
                />
              </div>
            ))}
          </div>
        </div>

        <AcquisitionReportsFilter
          callBack={(f) => this.setState({ filter: f })}
        />
      </div>
    );
  }
}
